import { useState } from 'react';

const DISMISSED_UNTIL_KEY = 'strava-capacity-notice-dismissed-until';
const DISMISSAL_MS = 14 * 24 * 60 * 60 * 1000;

function shouldShowNotice() {
  const dismissedUntil = Number(localStorage.getItem(DISMISSED_UNTIL_KEY));
  if (Number.isFinite(dismissedUntil) && dismissedUntil > Date.now()) return false;
  localStorage.removeItem(DISMISSED_UNTIL_KEY);
  return true;
}

export default function StravaCapacityNotice() {
  const [visible, setVisible] = useState(shouldShowNotice);

  function dismiss() {
    localStorage.setItem(DISMISSED_UNTIL_KEY, String(Date.now() + DISMISSAL_MS));
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <aside
      role="status"
      aria-label="Melding over Strava-koppelingen"
      className="fixed top-20 left-1/2 z-[9998] flex w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 items-start gap-3 rounded-lg border border-line bg-surface p-4 text-ink shadow-[0_4px_16px_rgba(0,0,0,0.18)]"
    >
      <p className="m-0 flex-1 text-[14.5px] leading-relaxed">
        We hebben het maximale aantal Strava-gebruikers bereikt. We werken eraan en hebben een
        verzoek bij Strava ingediend om dit aantal te verhogen. Zodra dat is aangepast, kun je
        Strava opnieuw koppelen.
      </p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Melding sluiten"
        className="flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-md text-2xl leading-none text-ink-3 hover:bg-surface-2 hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
      >
        <span aria-hidden="true">×</span>
      </button>
    </aside>
  );
}
